export enum TAssetTypeId {
  Image = 1,
  YouTubeVideo = 33,
  Unknown = 0
}

export enum TAssetType {
  Image = 'Image',
  YouTubeVideo = 'YouTubeVideo',
  Place = 'Place',
  Unknown = 0
}

export type TGetUniverseAssetIdsResponse =
  | {
      assetTypeId?: TAssetTypeId.Image;
      assetType: TAssetType.Image;
      imageId: number;
      approved: boolean;
    }
  | {
      assetTypeId?: TAssetTypeId.YouTubeVideo;
      assetType: TAssetType.YouTubeVideo;
      videoHash: string;
      videoTitle: string;
      approved: boolean;
    };

export type TCarouselItem =
  | {
      type: TAssetType.Image | TAssetType.Place | TAssetType.Unknown;
      assetId: number;
    }
  | {
      type: TAssetType.YouTubeVideo;
      assetId: string;
    };
